import '../scss/core.scss';
import $ from 'jquery';
window.$ = window.jQuery = $;
import AOS from 'aos';
/* Core */
import './vendor/foundation';
import * as stickyHeader from './core/modules/stickyHeader';
import * as primaryNav from './core/modules/primaryNav';
import slugify from 'slugify';
import * as stickyArticleAside from './core/modules/stickyArticleAside';
import * as breakoutSections from './core/modules/breakoutSections';
import * as footerLinks from './core/modules/footerLinks';
import * as megaMenu from './core/modules/megaMenu';
import * as featureList from './core/modules/featureList';
import * as newsPress from './core/modules/newsPress';
import * as glide from './core/modules/glide';
import * as gtm from './core/modules/clari-gtm';
import * as balanceText from './core/modules/balanceText.js';
import * as articleToc from './core/modules/articleToc';
import * as blockquote from './core/modules/blockquote';
import * as progressBar from './core/modules/progressBar';
import { throttle } from 'throttle-debounce';
import '@lottiefiles/lottie-player';
import 'tablesaw/dist/tablesaw.js';
import 'tablesaw/dist/tablesaw-init.js';
import * as triggeredAnimations from './core/modules/triggeredAnimations';
import * as emailValidation from './core/modules/emailValidation.js';

window.addEventListener('DOMContentLoaded', (event) => {
    breakoutSections.init();
    let mainNavToggle = document.getElementById('mainNavToggle');
    let tablesawTables = document.querySelectorAll('.tablesaw');
    if (mainNavToggle) {
        mainNavToggle.addEventListener('click', () => {
            document.body.classList.toggle('active');
        });
    }

    $(document).foundation();

    megaMenu.init();
    stickyHeader.init();
    stickyArticleAside.init();
    glide.init();
    primaryNav.addLastClass();
    primaryNav.toggleSubNav();
    featureList.init();
    newsPress.init();
    footerLinks.init();
    articleToc.init();
    blockquote.init();
    balanceText();
    progressBar.init();

    if (tablesawTables.length) {
        tablesawTables.forEach((table) => {
            Tablesaw.init(table);
            window.addEventListener(
                'resize',
                throttle(300, () => {
                    Tablesaw.init(table);
                })
            );
        });
    }

    AOS.init({
        once: true,
    });

    $('img').on('error', function () {
        $(this).hide();
    });

    let isColorDark = (hexColor) => {
        // Remove the '#' character if present
        hexColor = hexColor.replace('#', '');

        // Convert the hex color to RGB
        let red = parseInt(hexColor.substr(0, 2), 16);
        let green = parseInt(hexColor.substr(2, 2), 16);
        let blue = parseInt(hexColor.substr(4, 2), 16);

        // Calculate the relative luminance using the formula
        // Y = 0.2126 * R + 0.7152 * G + 0.0722 * B
        let luminance = (0.2126 * red + 0.7152 * green + 0.0722 * blue) / 255;

        // Determine if the color is dark or light based on the luminance threshold
        return luminance < 0.5;
    };

    let setupNavigationYoutubeVideos = () => {
        let navVideos = document.querySelectorAll('.js-nav-video');
        let player = null;
        if (navVideos.length) {
            //inject the youtube iframe api into the page
            if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
                // Load the IFrame Player API code asynchronously if not loaded already
                let tag = document.createElement('script');
                tag.src = 'https://www.youtube.com/iframe_api';
                let firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }
        }
        navVideos.forEach((navVideo) => {
            let modalID = navVideo.getAttribute('data-open');
            let playerID = navVideo.getAttribute('data-player-id');
            let youtubeID = navVideo.getAttribute('data-youtube-id');

            $(`#${modalID}`).on('open.zf.reveal', function () {
                if (player) {
                    player.destroy(); // Destroy existing player if it exists
                }

                player = new YT.Player(`${playerID}`, {
                    height: '390',
                    width: '640',
                    videoId: youtubeID,
                    playerVars: {
                        playsinline: 1,
                    },
                    events: {
                        onReady: onPlayerReady,
                    },
                });

                // 4. The API will call this function when the video player is ready.
                function onPlayerReady(event) {
                    event.target.playVideo();
                }
            });
        });
    };

    let setAuthorUrl = () => {
        let authorLinks = document.querySelectorAll('.js-get-author-slug');

        //dont run the function if it doesnt find any authorlinks
        if (!authorLinks.length) {
            return;
        }

        const options = {
            lower: true, // Convert the slug to lowercase (optional)
            strict: true, // Remove special characters
            replacement: '-', // Use a dash as the separator
        };

        authorLinks.forEach((link) => {
            let authorName = link.getAttribute('data-author-name');
            if (authorName) {
                link.setAttribute('href', `/blog/authors/${slugify(authorName, options)}`);
            } else {
                link.setAttribute('href', `#`);
            }
        });
    };

    let checkMenuHeightAtMobile = () => {
        const isMobile = window.matchMedia("(max-width: 1023px)").matches;

        let setHeight = () => {
            if(isMobile) {
                document.body.height = window.innerHeight;
            }
        }

        window.addEventListener('resize', throttle(100, () => {
	        setHeight();
        }));

        setHeight();
    };

    let formButtonStyling = () => {
        window.addEventListener('load', () => {
            let formsWithColorControl = document.querySelectorAll('[data-form-button-color]');

            if (!formsWithColorControl.length) {
                return;
            }

            formsWithColorControl.forEach((formEl) => {
                let buttonColor = formEl.getAttribute('data-form-button-color');
                let buttons = formEl.querySelectorAll('button');

                buttons.forEach((btn) => {
                    btn.setAttribute('style', `background: ${buttonColor}; opacity: 1; border-color: ${buttonColor}; color: ${isColorDark(buttonColor) ? '#ffffff' : '#000000'} !important;`);
                });
            });
        });
    };

    if (document.createElement('div').style.objectFit === undefined) {
        let blockFigures = document.querySelectorAll('.block__figure--cover');
        let len = blockFigures.length;

        for (let i = 0; i < len; i++) {
            let $container = blockFigures[i],
                imgUrl = $container.querySelector('img').getAttribute('src');

            if (imgUrl) {
                $container.style.backgroundImage = 'url(' + imgUrl + ')';
            }
        }
    }

    let qualifiedFormStyling = () => {
        function handleQualifiedOfferHostDiv(divElement) {
            let shadowRootElement = document.querySelector('[id^="_qualified-offer-host"] > div').shadowRoot;
            shadowRootElement.querySelector('[class^="input-FormModal"]').style.background = 'white';
        }

        // Create a MutationObserver instance
        const observer = new MutationObserver((mutationsList, observer) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            if (node.matches('div[id^="_qualified-offer-host"]')) {
                                handleQualifiedOfferHostDiv(node);
                            }
                        }
                    });
                }
            }
        });

        // Start observing for the shadow-root inclusion;
        observer.observe(document.body, { childList: true, subtree: true });
    }

    formButtonStyling();
    qualifiedFormStyling();
    setAuthorUrl();
    setupNavigationYoutubeVideos();
    triggeredAnimations.init();
    checkMenuHeightAtMobile();
    gtm.init();
    emailValidation.init();

    console.log('clari ui load');
});
